import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { PatientService } from 'src/app/services/patient.service';
import { ProblemService } from 'src/app/services/problem.service';
import { ProblemTableComponent } from '../problem-table/problem-table.component';

declare var Ext: any;

@ManageType('ProblemPanelComponent')
@Component({
  selector: 'app-problem-panel',
  templateUrl: './problem-panel.component.html',
  styleUrls: ['./problem-panel.component.scss']
})
export class ProblemPanelComponent implements OnInit {

  @ViewChild('problemtable') problemTable: ProblemTableComponent;

  constructor(private patient: PatientService, private ngZone: NgZone,
              public problemservice: ProblemService) { }

  ngOnInit(): void {

  }

  newProblem(): void {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const patient = new Ext.CNPatient(this.patient.patient.id);
        patient.on('itemLoaded', (item) => {
          const problemwindow = new Ext.CNProblemWindow({ patient: item });
          problemwindow.show();
          problemwindow.on('problemCreated', () => {
            setTimeout(() => {
              this.reload();
            });
          });
        });
      });
    });
  }

  reload() {
    this.ngZone.run(() => {
//      this.problemservice.dataStart = 0;
      this.problemservice.reloadAllSubjects();
    });
  }
}
